import { createContext } from 'react';
import { SignedContract, ApplicationContract } from '../components/Complete/ContractComplete.types';
import { LogoId } from '../../assets-component-library/images/images.types';
import { Business } from '../capitalAccounts/capitalAccountClient';

export interface AppContextType {
  partnerCode: string;
  isPrimary: boolean;
  isInIframe: boolean;
  logo: {
    logoId: LogoId;
    width: string;
    isInternal: boolean;
    alt?: string;
  };
  logoSrc?: string;
  phoneNumber: string;
  impressumLink?: string;
  privacyPolicyLink: string;
  termsConditionsLink: string;
  cookieNoticeLink: string;
  disclaimerKey: string;
  packType: string;
  signedContracts: Array<SignedContract>;
  applicationContract: ApplicationContract;
  capitalAccountData?: Business;

  setState: (key: AppContextKeys, val: AppContextValues) => void;
  setSignedContracts: (contracts: Array<SignedContract>) => void;
  setApplicationContract: (applicationContract: ApplicationContract) => void;
}
type AppContextKeys = keyof AppContextType;
type AppContextValues = AppContextType[keyof AppContextType];
export const initialContext: AppContextType = {
  partnerCode: '',
  isPrimary: false,
  isInIframe: false,
  logo: {
    logoId: LogoId.LIBERIS_BLACK,
    width: '',
    isInternal: false,
  },
  phoneNumber: '',
  impressumLink: '',
  privacyPolicyLink: '',
  termsConditionsLink: '',
  cookieNoticeLink: '',
  signedContracts: [],
  applicationContract: { applicationId: '', applicantId: '' },
  disclaimerKey: '',
  packType: '',

  setState: () => {},
  setSignedContracts: () => {},
  setApplicationContract: () => {},
};

export const AppContext = createContext(initialContext);
export { AppContextKeys, AppContextValues };
